import moment from 'moment'
import { useEffect, useState, useRef } from 'preact/compat'

const momentFormat = (dateFormat) =>
  dateFormat.replace('%d', 'DD').replace('%m', 'MM').replace('%Y', 'YYYY')

const formatPattern = (format) =>
  format
    .replace('YYYY', '\\d{4}')
    .replace('MM', '\\d{1,2}')
    .replace('DD', '\\d{1,2}')
    .replace(/\//, '\\/')
    .replace(/\./, '\\.')

export const ChangeDate = ({ spentDate, dateFormat, onChange }) => {
  const [showInput, setShowInput] = useState(false)

  const momentDateFormat = momentFormat(dateFormat)

  const parseSpentAt = (evt) => {
    const parsedDate = moment(evt.currentTarget.value, momentDateFormat)

    if (parsedDate.isValid()) {
      onChange(parsedDate)
    }
  }

  const onClick = () => setShowInput(true)
  const input = useRef()

  useEffect(() => {
    input.current?.focus()
  }, [showInput])

  if (showInput) {
    return (
      <input
        ref={input}
        type="text"
        className="pds-input pds-input-sm input-spent-date"
        autoComplete="off"
        onChange={parseSpentAt}
        pattern={formatPattern(momentDateFormat)}
        defaultValue={spentDate.format(momentDateFormat)}
        aria-label="Spent date."
      />
    )
  }

  return (
    <button className="pds-button-link pds-button-sm" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="pds-mr-xs"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="currentColor"
      >
        <path d="M2 5h2v2H2V5zm3 0h2v2H5V5zm3 0h2v2H8V5zm0 3h2v2H8V8zM5 8h2v2H5V8zM2 8h2v2H2V8zm9-8H7v1H5V0H1v1H0v11h12V1h-1V0zM8 1h2v1H8V1zM2 1h2v1H2V1zM1 11V4h10v7H1z" />
      </svg>
      Change Date
    </button>
  )
}
